import { Select as SelectAntd } from 'antd';
import s from './index.module.css';
import { SearchOutlined } from "@ant-design/icons";
import classNames from 'classnames';

const Select = ({fields, className='', wrapperClassName=''}) => {
  
    return (
         <div className={
            classNames(
                s.selectWrapper,
                {[wrapperClassName]: !!wrapperClassName}   
            )
         }>
                {
                    (fields?.value?.length === 0 || !fields.value || fields.mode !== 'multiple') && (
                        <SearchOutlined className={s.searchIcon} />
                    )  
                }
                <SelectAntd 
                    className={
                        classNames(
                            'multipleSearhNewDesign',
                            s.select,
                            {[className]: !!className})}
                    {...fields} />
           </div>
    );
};

export default Select;
